export interface IUserLogon {
  isLoggedOn: boolean
  isInternalUser: boolean
  isRememberMeEnabled: boolean
  userName: string
}

export function initializeIUserLogonObject() {
  return {
    isLoggedOn: false,
    isInternalUser: false,
    isRememberMeEnabled: false,
    userName: '',
  }
}
